<template>
	<div :class="['o-width-limiter o-width-limiter--main t-margin--5-top t-margin--5-bottom', className]">
		<div
			:class="[
				{
					'c-info-video-block--video-left': videoAlignment === 'left'
				},
				{
					'c-info-video-block--video-right':
						videoAlignment === 'right'
				},
				'o-grid',
				'c-info-video-block'
			]"
		>
			<div class="o-grid__column" data-size="sm:12 md:9">
				<div
					:class="[
						'c-info-video-block__content',
						color === 'orange' && 'c-info-video-block--orange',
						color === 'pink' && 'c-info-video-block--pink',
						color === 'blue' && 'c-info-video-block--blue',
						color === 'green' && 'c-info-video-block--green'
					]"
				>
					<div class="c-info-video-block__content-wrapper">
						<div class="heading-header">
							<h2
								class="c-info-video-block__heading heading-boarder"
							>
								{{ heading }}<br />
								{{ subHeading }}
							</h2>
							<img
								class="c-info-video-block--icon"
								:src="`/gui/images/icons/${icon}.svg`"
								:alt="icon"
							/>
						</div>
						<p v-if="text" class="c-info-video-block__text">
							{{ text }}
						</p>
					</div>
				</div>
			</div>

			<video-player
				v-if="!isImage && !youTubeUrl"
				class="c-info-video-block__video"
				:options="videoOptions"
			></video-player>

			<div class="c-info-video-block__youtube">
				<you-tube-player v-if="!isImage && youTubeUrl" :url="youTubeUrl"></you-tube-player>
			</div>

			<img v-if="isImage" :src="imageSrc" :alt="imageAlt" class="c-info-video-block__video" />
		</div>

		</div>
	</div>
</template>

<script>
import VIcon from "../icon/VIcon.vue";
import VideoPlayer from "../video-player/VideoPlayer.vue";
import YouTubePlayer from "../you-tube-player/YouTubePlayer.vue";
export default {
	name: "VInfoVideoBlock",
	components: {
		VIcon,
		VideoPlayer,
		YouTubePlayer
	},
	data() {
		return {
			videoOptions: {
				controls: true,
				sources: [
					{
						src: this.src,
					}
				],
				responsive: true,
				aspectRato: "16:9",
				fluid: true,
				poster: this.thumb
			}
		};
	},
	props: {
		heading: {
			type: String
		},
		subHeading: {
			type: String
		},
		text: {
			type: String
		},
		url: {
			type: String
		},
		youTubeUrl: {
			type: String
		},
		buttonText: {
			type: String
		},
		src: {
			type: String
		},
		thumb: {
			type: String
		},
		isImage: {
			type: Boolean
		},
		imageSrc: {
			type: String
		},
		imageAlt: {
			type: String
		},
		icon: {
			type:
				"attractive" |
				"carreer" |
				"environment" |
				"flexibility" |
				"new" |
				"social"
		},
		title: {
			type: String
		},
		videoAlignment: {
			type: "right" | "left"
		},
		color: {
			type: "orange" | "blue" | "pink" | "green"
		},
		className: {
			type: String
		}
	}
};
</script>
